import LeftPixelButton from '../../assets/Buttons/LeftPixelButton';
import RightPixelButton from '../../assets/Buttons/RightPixelButton';

type PixelButtonProps = {
  color: string;
  label: string;
  innerWidth?: number | string;
  onClick: () => void;
}

export default function PixelButton({ color, label, innerWidth, onClick }: PixelButtonProps) {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
      justifyContent: 'center',
      gap: 0,
    }}>
      <LeftPixelButton color={color} />
      <div style={{
        backgroundColor: color,
        color: 'white',
        fontSize: '15px',
        height: '36px',
        fontWeight: 700,
        fontFamily: 'Inter-Medium',
        marginLeft: -1,
        marginRight: -1,
        padding: '0 8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: innerWidth
      }} onClick={onClick}>
        {label}
      </div>
      <RightPixelButton color={color} />
    </div>
  )
}